(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      accounts:{
        "overpayAmount": "Iznos preplate",
        "installmentDivided": "Podijeljeno na rate",
        "accAllAccountsOverview":"Pregled svih računa",
        "accAccountsAndCardsOverview": "Pregled svih računa i kartica",
        "accShowAccounts":"Prikaži još računa",
        "accFilter":"Filtriraj po tipu",
        "accAmountRange":"Raspon iznosa",
        "accTo":"Do",
        "accApply":"Primijeni",
        "accReset":"Poništi",
        "accPeriod":"Period",
        "accDescription":"Opis",
        "accAmount":"Iznos",
        "accBalance":"Dospjeli troškovi",
        "accShowOnDashboard":"Prikaži na kontrolnoj ploči",
        "accTransactions":"Pregled prometa",
        "accPdfStatements":"Izvodi(PDF)",
        "accDownloadPdf":"Preuzmi PDF",
        "accChangeName":"Promijeni naziv računa",
        "accResetName":"Postavi izvorni naziv",
        "accQuickPayment":"Brzo plaćanje",
        "accRequestLimit":"Zahtijevaj promjenu limita",
        "accAvailableToSpend":"Raspoloživi iznos",
        "accReservations":"Rezervacije",
        "accReservationsCardReservationAmount":"Rezervirano kartičnim plaćanjem",
        "accOverdraftLimit":"Iznos prekoračenja",
        "accOverdraftLimitDue":"Datum isteka prekoračenja",
        "accPayIn":"Uplata",
        "accRepaymentPlan":"Prikaži plan otplate",
        "accLoanAmount":"Odobreni iznos",
        "accLoanBalance":"Stanje kredita",
        "accInterestRate":"Kamatna stopa",
        "accAnnuity":"Iznos anuiteta/rate",
        "accStartDate":"Datum početka",
        "accEndDate":"Datum završetka",
        "accDisbursementDate":"Datum odobrenja",
        "accDuration":"Trajanje",
        "accViewMore":"Prikaži više informacija",
        "accViewLess":"Prikaži manje informacija",
        "accTypeOfRate":"Vrsta kamatne stope",
        "accPenaltyInterests":"Zatezna kamata",
        "accOverpayments":"Preplata",
        "accOtherFees":"Druge naknade",
        "accChangeDate":"Datum zadnje promjene",
        "accAlreadySpent":"Dospjeli troškovi",
        "accPayCard":"Kartično plaćanje",
        "accApprovedLimit":"Odobreni limit",
        "accDueDate":"Rok korištenja",
        "accClosingDate":"Datum zatvarnja",
        "accMonthlyDeposit amount":"Iznos mjesečnog depozita",
        "accStatementDeliveryMethod":"Način isporuke obračuna",
        "accAccountForRelease":"Račun za isplatu",
        "accAnnualAssignment":"Godišnja dodjela kamata",
        "accPayOut":"Isplata",
        "accCloseAccount":"Zatvori račun",
        "accOpenNewSavingsAccount":"Otvori novi štedni račun",
        "accEg":"npr",
        "accSearchTransactionsPlaceholder":"Pretraži transakcije",
        "accCancelDeposit":"Otkaži oročenje",
        "accCancelAutoExtension":"Otkaži automatsko produženje",
        "accNewDeposit":"Novo oročenje",
        "accPrincipal":"Glavnica",
        "accInterest":"Kamata",
        "accMaturityDate":"Datum dospijeća",
        "accCurrentBalance":"Trenutno stanje",
        "accAtmWithdrawalLimit":"Limit za preuzimanje na bankomatu",
        "accPosPaymentLimit":"Limit za preuzimanje u poslovnici",
        "accDateLastChanged":"Datum zadnje promjene",
        "accBalanceDateLastChanged":"Datum zadnje promjene ",
        "accAutorization":"Autorizacija",
        "accProvedena":"Provedena",
        "accAvailableBalance":"Raspoloživo stanje",
        "accSearchAccountsPlaceholder":"Pretraži račune",
        "accShowMatured":"Prikaži zatvorene račune",
        "accAuthorizedPersons":"Ovlaštene osobe",
        "accCardStatus":"Status kartice",
        "accContractNumber":"Broj ugovora",
        "accDepositStartDate":"Datum oročenja",
        "accDepositEndDate":"Datum isteka oročenja",
        "rename": "Preimenuj",
        "accAccountAndCardsMoreDetails": "Detaljni prikaz",
        "accAccountAndCardsMoreDetails1": "Detalji i platne kartice",
        "accAccountAndCardsLessDetails": "Manje detalja",
        "accInstallmentsPayed":"Rata plaćeno",
        "accInstallmentNumber": "Ukupan broj rata",
        "accInstallmentsRemain":"Preostali broj rata",
        "accNextInstallmentDate":"Datum sljedeće rate",
        "accNextInstallmentAmount":"Iznos sljedeće rate",
        "connectedDebitCards": "Povezane kartice",
        "blockCard": "Blokiraj karticu",
        "unblockCard": "Odblokiraj karticu",
         "blockCardRequest": "Zahtjev za blokadu",
        "unblockCardRequest": "Zahtjev ",
        "accDueAmount": "Ukupan dospjeli dug",
        "accMatureInterest":"Dospjela redovna kamata",
        "accNewEbook": "Nova eKnjižica",
        "closeEbook": "Zatvaranje eKnjižice",
        "accPaymInQue": "Broj nerealiziranih čekova",
        "accReservedAmount": "Rezervirani iznos",
        "accPlanedDebit": "Rezervacija",
        "accDepositInterestRate": "Kamatna stopa na depozit",
        "accDepositTypeExternal": "Deposit Type External",
        "accDepositPrincipal": "Ugovoreni iznos depozita",
        "accLimitValidUntilDate": "Datum isteka kartice",
        "accObligationAmount": "Tekući troškovi",
        "accOutstandingAmount": "Nedospjele obveze na rate",
        "accCardNumber": "Broj kartice",
        "accInstallmentPaidNumber": "Broj plaćenih rata",
        "accNotMatureCapital": "Nedospjela glavnica",
        "accNewDebitDate": "Datum iduće obveze",
        "title": "Informacija",
        "message":"Molimo Vas nazovite Kontakt centar na besplatni broj telefona 0800 14 14 ili na +385 1 6030 000 za pozive iz inozemstva.",
        "close": "Zatvori",
        "accHideTransactions": "Sakrij transakcije",
        "balance": "Stanje računa",
        "accParentAccountIban": "Glavni račun",
        "accAnnuityConverted": "Iznos anuiteta u ",
        "accNotMatureCapitalConverted": "Nedospjela glavnica u ",
        "closeRepaymentPlan":"Zatvori otplatni plan",
        "accHideReservations": "Sakrij rezervacije",
        "depositCantBeCanceledError": "Prijevremeni prekid oročenja moguć je samo za oročenja ugovorena putem usluga direktnog bankarstva. ",
        "Active":"Aktivan",
        "BlockedFromEBank":"Blokirano iz E-banke",
        "expDate":"Datum isteka kartice: ",
        "accTotalMatureConverted": "Ukupan dospjeli dug u ",
         "Closed":"Zatvoren",
        "eBookPayIn": "Uplata na eKnjižicu",
        "eBookPayOut": "Isplata sa eKnjižice",
        "Blocked":"Blokiran",
        "transDivisionBtn1": "Podijeli",
        "transDivisionBtn2": "na rate",

        "obligationAmountCard": "Tekući troškovi",
        "outstandingAmountCard": "Nedospjele rate",
        "reservedAmount": "Rezervirani iznos",
        "outstandingDebitAmountCard": "Nepodmireni dospjeli dug",
        "statementDateCard": "Podaci s izvatka",
        "usedAmountCard": "Ukupan dug s izvatka",
        "minimalDebitCard": "Minimalni iznos za platiti",
        "minimalDebitUntilDateCard": "Datum dospijeća plaćanja",
        "cardExpieryDateCard": "Datum isteka kartice",
        "interestRateAmountCard": "Ugovoreni način podmirenja troškova"
      },
      repaymentPlan: {
        "instalment": "Rata",
        "loanBalance": "Iznos duga",
        "date": "Datum",
        "dateFrom":"Datum od",
        "dateTo":"Datum do",
        "principalAmount": "Glavnica",
        "paymentAmount": "Anuitet",
        "interestAmount":"Kamata",
        "totalAnnuity":"Ukupan iznos za otplatu",
        "balance": "Stanje"
      },
      transactions: {
        "description":"Opis",
        "amount":"Iznos",
        "statusTransaction":"Status transakcije",
        "availableAmount":"Raspoloživi iznos",
        "accountNumber":"Broj računa",
        "bookingDate":"Datum knjiženja",
        "valueDate":"Datum valute",
        "cardTransactionDetails":"Detalji transakcije",
        "transactionDetails":"Detalji transakcije",
        "close":"Zatvori",
        "card":"Kartica",
        "iban":"IBAN",
        "noData":"Za odabrani period nema podataka za prikaz",
        "noStatementData":"Za odabrani račun nema podataka za prikaz",
        "retrieval": "Povrat",
        "ibanFrom": "IBAN platitelja",
        "accountFrom": "Račun platitelja",
        "accountTo": "Račun primatelja",
        "referenceNumber":"Referentni broj",
        "creditorName": "Platitelj",
        "debitorName": "Primatelj",
        "creditorAddress": "Adresa platitelja",
        "debitorAddress": "Adresa primatelja",
        "date":"Datum transakcije",
        "MCC": "MCC",
        "POSReference": "Referenca transakcije na prodajnom mjestu",
        "POSIPS": "POS_IPS"
      },
      merchant: {
        'address': 'Adresa',
        'contact': 'Kontakt',
        'website': 'Website',
        'location': 'Lokacija',
      },
      ebook: {
        "header": "Zahtjev za otvaranje nove eKnjižice",
        "date": "Datum",
        "fullName": "Ime i prezime",
        "firstName": "Ime",
        "lastName": "Prezime",
        "fromAccount": "Račun",
        "eSavingsBookName": "Naziv eKnjižice",
        "iAccept": "Prihvaćam",
        "documents": "Dokumenti",
        "otherDocs1": "Ostalu dokumentaiju povezanu s ugovaranjem e-knjizice mozete pronaci",
        "otherDocs2": "ovdje",
        "termsAndConditions": "Opći uvjeti otvaranja i vođenja eknjižice",
        "termsAndConditions2": "Obrazac o informacijama prije zaključenja Ugovora o depozitu",
        "requestForEBook": "Zahtjev za otvaranjem eknjižice",
        "informationFormOnDeposits": "Obrazac informacija o osiguranju depozita",
        "signTitle": "Potpis eKnjižice",
        "signActionLabel": "Potpiši",
        "linksHeader": "Ostalu dokumentaciju povezanu s ugovaranjem eknjižice pogledajte ",
        "linksHeaderLink": "ovdje",

        "link1": "Opći uvjeti poslovanja",
        "link2": "Izvadak iz Odluke o visini pasivnih kamatnih stopa za fižicke osobe",
        "link3": "Odluka o naknadama za usluge Banke",
        "link4": "Opći uvjeti otvaranja i vođenja e-knjižice za potrošace",
        "doc1": "Zahtjev za otvaranje e-knjižice",
        "doc2": "Obrazac o informacijama prije zaključenja ugovora o depozitu",
        "doc3": "Informacije prije sklapanja ugovora o e-knjižici",
        "doc4": "Opći uvjeti otvaranja i vođenja e-knjižice za potrošače",
        "preContractInfo": "Informacije prije sklapanja ugovora o eKnjižici",
        "confirm": "Potvrdi",
        "cancel": "Odustani",
        "dateOfCreation":"Datum kreiranja",
        "mainAccount":"Glavni račun",
        "delete":"Izbriši",
        "ebookOrder":"eKnjižica",
        "sign":"Potpiši",
        "name":"Naziv",
        "edit":"Promijeni",
        "enterName": "Unesite naziv",
        "nameError": "Naziv eKnjižice je obavezan!",
        "createEbook": "Kreiraj eKnjižicu",
        "successfullRequest": "Uspješno ste kreirali eKnjižicu",
        "completeRequest": "Zahtjev uspješan!",
        "eBookRequests": "Zahtjevi za eKnjižicu",
        "createdBy": "Kreirao",
        "iban": "IBAN",
        "requestType": "Tip zahtjeva",
        "status": "Status",
        "timelineHeader":"Vremenski prikaz zahtjeva za eKnjižice",
        "showAllRequests": "Prikaži zahtjeve za sve račune",
        "ebookNumber": "Račun eKnjižice"
      },
      closeEBookPageTranslation: {
        title: "Zahtjev za zatvaranje eKnjižice",
        account: "Broj eKnjižice",
        accountName: "Naziv eKnjižice",
        currency: "Valuta",
        balance: "Stanje",
        recognisedInterestRate: "Priznata kamatna stopa",
        recognisedInterestAmount: "Iznos priznate kamatne stope",
        fee: "Naknada",
        transferAmount: "Iznos za prijenos",
        transferAccount: "Račun za prijenos",
        confirmButton: "Potvrdi",
        cancelButton: "Otkaži"
      },
      accountsOverview: {
        "title": "Pregled svih računa i kartica",
        "newTermDepositButtonLabel": "Dodaj novo oročenje",
        "newESavingAccountButtonLabel": "Dodaj novu eKnjižicu"
      },
      depositAccountsOverview: {
        "title": "Pregled svih oročenja i eKnjižica",
        "titleForSlo": "Pregled depozitov in varčevanj",
        "titleForSerbAndMne": "Pregled svih oročenja"
      },
      laonsOverview: {
        title: "Pregled kredita"
      },
      cashWithdrawalTranslate: {
        title: "Najava podizanja gotovine",
        infoNote1: "Gotovinske isplate stranog / domaćeg efektivnog novca veće od 5.001,00 EUR / 35.001,00 EUR potrebno je najaviti 3 dana unaprijed.",
        infoNote2: "U slučaju nepodizanja gotovine Banka će teretiti Vaš račun za iznos naknade prema važećoj tarifi Banke.",
        fromAccount: "Na teret IBAN-a",
        amount: "Iznos",
        amountRequired: "Iznos je obavezan!",
        dateOfPayout: "Datum isplate",
        phoneNumber: "Telefonski broj",
        placeOfCashTakeover: "Mjesto preuzimanja gotovine",
        placeOfCashTakeoverRequiredMsg: "Mjesto preuzimanja gotovine je obavezno!",
        note: "Napomena",
        confirmBtnLabel: "Potvrdi",
        cancelBtnLabel: "Odustani",
        amountMinAmountError: "Minimalni iznos je "
      },
      reservations: {
        "reservationDate":"Datum rezervacije",
        "transactionType":"Tip transakcije",
        "noData": "Nema dostupnih rezervacija",
        "type": "Type",
        "originAmount": "Iznos u originalnoj valuti"
      },
      transactionDivision: {
        "Cancelled": "Opozvan",
                "Processed": "Obrađen",
                "Rejected": "Odbijen",
                "Opened": "Kreiran",
                "InProcessing": "U obradi",
                "WaitingQueue": "Na čekanju",
                "Signed": "Potpisan",
        "title": "Podjela transakcija",
        "backToTransactions":"Nazad na transakcije",
        "creationDate": "Datum podjele na rate",
        "fullName": "Ime i prezime",
        "jmbg": "JMBG",
        "transactionDate": "Datum transakcije",
        "amount": "Iznos",
        "successMessageCro":"Uspješno ste zadali nalog za podjelu transakcije „opis transakcije“ u iznosu od {{value1}} EUR na {{value2}} rata. Podjela na rate bit će izvršena u roku od 48h.",
        "finalStepStatus": "Uspješno ste zadali nalog za podjelu transakcije „opis transakcije“ u iznosu od {{value1}} EUR na {{value2}} rata. Podjela na rate bit će izvršena u roku od 48h.",
        "numOfInstallment": "Izaberite broj rata",
        "sellingPlace": "Naziv prodajnog mjesta",
        "lastDigits": "Zadnja 4 broja sa kartice",
        "sellingPlaceError": "Naziv prodajnog mjesta je obavezno!",
        "lastDigitsError": "Zadnja 4 broja sa kartice su obavezna!",
        "lastDigitsLengthError": "Broj mora imati 4 znamenke!",
        "yourTransDiv": "Zahtjevi za podjelu transakcija",
        "transLocation": "Prodajno mjesto",
        "cardNumber": "Broj kartice",
        "status": "Status zahtjeva",
        "creatorName": "Kreator",
        "installmentNumber": "Broj rata",
        "installmentAmount": "Iznos rate",
        "feeInfo": "Naknada za obročnu otplatu transakcija kupovine ili podizanja gotovine podijeljenih na rate naplaćuje se sukladno važećim Naknadama za usluge Addiko Bank. Ukoliko ste navedenu transakciju već podijelili na rate pozivom u Kontakt Centar ili putem Addiko internetskog ili mobilnog bankarstva, molimo da ju ne dijelite ponovno.",
        "fee": "Naknada za podjelu na rate",
        "cancel": "Odustani",
        "confirm": "Potvrdi"
      }
    };

    $translateProvider
      .translations('hr', data);

  }
}());
